import {useState} from "react";
import {Tab, Tabs} from "react-bootstrap";
import {ReactComponent as RouteIcon} from "../../../../../asset/icons/customer-club-route-icon.svg";
import {ReactComponent as BackIcon} from "../../../../../asset/icons/backIcon.svg";
import "./style.scss";
import SocialShare from "./SocialShare";
import BetweenUsers from "./BetweenUsers";
import BetweenGroups from "./BetweenGroups";
import {useTranslation} from "react-i18next";

export default function ShareContent({onHide, content}) {
  const [activeTab, setActiveTab] = useState("1");
  const {t} = useTranslation();

  return (
    <>
      <div className="modal-title">
        <div className="title-box">
          <RouteIcon/>
          <span>
              {t(
                "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.Title"
              )}
          </span>
        </div>
        <button onClick={onHide}>
          <BackIcon/>
        </button>
      </div>
      <div className="tab-section">
        <Tabs
          activeKey={activeTab}
          transition={false}
          className="panel_tab"
          onSelect={(e) => setActiveTab(e)}
        >
          <Tab
            eventKey="1"
            className="panel_tab_item"
            title={t(
              "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.Index.1"
            )}
          />
          <Tab
            eventKey="2"
            className="panel_tab_item"
            title={t(
              "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.Index.2"
            )}
          />
          <Tab
            eventKey="3"
            className="panel_tab_item"
            title={t(
              "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.Index.3"
            )}
          />
        </Tabs>
        {activeTab === "1" && <SocialShare content={content}/>}
        {activeTab === "2" && <BetweenGroups content={content}/>}
        {activeTab === "3" && <BetweenUsers content={content}/>}
      </div>
    </>
  );
}
